<template>
  <div class="signIn">
    <amplify-authenticator :authConfig="authConfig"></amplify-authenticator>
    <div v-if="signedIn"></div>
  </div>
</template>

<script>
import { Auth, Hub } from "aws-amplify";
import DefaultLayout from "@/layouts/DefaultLayout";
import { AmplifyEventBus } from "aws-amplify-vue";
export default {
  data() {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false,
        },
      },
      username: "",
      message: {
        showError: false,
        errorMessage: null,
        show: false,
        message: null,
      },
    };
  },
  created() {
    Hub.listen("auth", async (state) => {
      if (state.payload.event === "signIn") {
        this.$emit(`update:layout`, DefaultLayout);
        this.findUser();
        this.$store.state.signedIn = true;
      } else {
        this.$emit(`update:layout`, FullPageLayout);
        this.$store.state.signedIn = false;
      }
    });
    this.findUser();
  },
  methods: {
    async findUser() {
      const user = await Auth.currentAuthenticatedUser()
        .then((data) => {
          // this.$cookie.set(
          //   "AWSTOKEN",
          //   data.signInUserSession.accessToken.jwtToken,
          //   { expires: "1Y", domain: "hpapps.healthyperformance.co.uk" }
          // );
          this.$store.state.signedIn = true;
          this.$store.state.user = data;
          this.$router.push({ path: "/" }, () => {});
        })
        .catch((err) => {
          this.$store.state.signedIn = false;
          console.log(err);
        });
    },
  },
  computed: {
    signedIn() {
      return this.$store.state.signedIn;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
